module.exports = __webpack_public_path__ + "img/shop-service-filter-lincoln.4bd46051.png";